<script setup lang="ts">
import { useLayoutStore } from '@/stores/layoutStore';
import { onMounted, useTemplateRef } from 'vue';
import BaseLayoutHeader from './BaseLayoutHeader.vue';
import BaseLayoutPrototypeWarning from './BaseLayoutPrototypeWarning.vue';
import BaseLayoutSubnavigation from './BaseLayoutSubnavigation.vue';
import { useSystemStore } from '@/stores/systemStore';

const systemStore = useSystemStore();

const appContentRef = useTemplateRef<HTMLElement>('appContent');
const { setAppContentElement } = useLayoutStore();
onMounted(() => {
  if (appContentRef.value) {
    setAppContentElement(appContentRef.value);
  }
});
</script>

<template>
  <v-layout id="base-layout">
    <BaseLayoutHeader />
    <v-main id="appContent" ref="appContent">
      <BaseLayoutSubnavigation />
      <slot />
    </v-main>
    <BaseLayoutPrototypeWarning v-if="systemStore.isPrototype" />
  </v-layout>
</template>

<style lang="scss" scoped>
#appContent {
  height: 100vh;

  // hide the shadow of the subnavigation bar if there is a page title
  &:has(.pageTitle) {
    :deep(.subnavigationBar) {
      &::after {
        display: none;
      }
    }
  }
}
#base-layout {
  position: relative;
}
</style>
